import { Component } from '@angular/core';

import { App, NavController, ModalController, ViewController } from 'ionic-angular';


@Component({
    template: `
    <ion-list>
        <button ion-item (click)="close('messaging')">Tous mes messages</button>
        <button ion-item (click)="close('delete')">Supprimer la discussion</button>
    </ion-list>
  `
})
export class MessagingPopover {

    constructor(
        public viewCtrl: ViewController,
        public navCtrl: NavController,
        public app: App,
        public modalCtrl: ModalController
    ) { }
    support() {
        this.app.getRootNav().push('SupportPage');
        this.viewCtrl.dismiss();
    }
    close(action) {
        this.viewCtrl.dismiss(action);
    }
}


// WEBPACK FOOTER //
// ./src/pages/support/popover.ts